import Wrapper from "../../../layout/Wrapper";
import ApproveSpecialAgentCommisionComponent from "../../../screens/approveds/special-agent-commission";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Approved Special Agent Commision",
	description: "",
};

export default function ApproveSpecialAgentCommision() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ApproveSpecialAgentCommisionComponent />
		</Wrapper>
	);
}